import axio from "axios";

export default {
  list_localidad_sisa: ["AMSS", "CA", "FORANEOS", "OTRAS CIUDADES", "NO COBRO"],
  list_cartera: [
    "FUTURO ASISTENCIA",
    "QUALITAS COMPAÑIA DE SEGUROS",
    "QUALITAS COSTA RICA",
    "QUALITAS MEXICO",
    "SEGUROS LA CEIBA",
    "SEGUROS UNIVERSALES",
    "LA GENERAL",
    "LA RESURRECCION",
    "ASISTENCIA REGIONAL",
    "BAM",
    "ASSA COMPAÑIA DE SEGUROS",
    "G&T",
    "APPMOVIL",
    "SEGUROS FICOHSA",
    "SEGUROS EL ROBLE",
    "SEGUROS CONTINENTAL SA",
    "SEGUROS AZUL",
    "AIS",
    "MAPFRE",
    "SISA SEGUROS",
    "NO REQUERIDO",
  ],
  list_pais: [
    "EL SALVADOR",
    "GUATEMALA",
    "HONDURAS",
    "NICARAGUA",
    "COSTA RICA",
    "PANAMÁ",
    "BELICE",
    "MÉXICO",
    "NO REQUERIDO",
  ],
  list_depaSiniestro: [
    "AHUACHAPAN",
    "CABAÑAS",
    "CHALATENANGO",
    "CUSCATLAN",
    "LA LIBERTAD",
    "LA PAZ",
    "LA UNION",
    "MORAZAN",
    "SAN MIGUEL",
    "SAN SALVADOR",
    "SAN VICENTE",
    "SANTA ANA",
    "SONSONATE",
    "USULUTAN",
    "NO REQUERIDO",
  ],
  list_muniSiniestro: ["NO REQUERIDO"],
  list_causa: [
    "VUELTA INDEBIDA RECIBIR",
    "ALCANCE DAR",
    "ALCANCE RECIBIR",
    "ATROPELLAMIENTO",
    "ATROPELLAMIENTO PEATON",
    "ATROPELLAMIENTO ANIMAL",
    "CAIDA DE OBJETOS",
    "CAIDA DE PASAJERO",
    "CAMBIO DE LLANTA",
    "CERRAJERIA",
    "CIRCULAR EN SENTIDO CONTRARIO",
    "COLISION POR IR EN REVERSA DAR",
    "COLISION POR IR EN REVERSA RECIBIR",
    "CORTE DE CIRCULACION",
    "CRUCERO PREFERENCIAL DE PASO DAR",
    "CRUCERO PREFERENCIAL DE PASO RECIBIR",
    "ENTRADA Y SALIDA DE COCHERA (CON PROYECCION)",
    "ESTACIONADO DAR",
    "ESTACIONADO RECIBIR",
    "ESTADO DE EBRIEDAD",
    "EXCESO DE ALTURA",
    "EXCESO DE VELOCIDAD",
    "EXPLOSION",
    "FALLA MECANICA",
    "FALLA MECANICA CON PROEYECCION",
    "FALTA DE PERICIA",
    "HECHO VANDALICO",
    "HUELGA Y ALBOROTOS",
    "HURACAN Y GRANIZO",
    "INCENDIO",
    "INTERVENCION DE AJUSTADOS",
    "INUNDACION",
    "INVASION DE CARRIL DAR",
    "INVASION DE CARRIL RECIBIR",
    "NO RESPETAR SEMAFORO",
    "NO RESPETAR SEÑALAMIENTOS",
    "OTROS",
    "PROYECCION CONTRA UN OBJETO",
    "PROYECCION DE N/A POR EVITAR COLISION",
    "ROBO PARCIAL",
    "ROBO RECUPERADO CON DAÑOS",
    "ROBO RECUPERADO SIN DAÑOS",
    "ROBO TOTAL",
    "ROTURA DE CRISTALES",
    "SOBREPESO",
    "TERREMOTO Y/O ERUPCION VOLCANICA",
    "VOLCADURA",
    "VUELTA INDEBIDA DAR",
    "NO REQUERIDO",
  ],
  list_tipoServicio: [
    "ADICIONAL",
    "EMERGENCIA",
    "CONEXION",
    "GESTION ADMINISTRATIVA",
    "CORTESIA",
    "NO REQUERIDO",
  ],
  list_proveedor: [
    "AIS",
    "ASAVIALES",
    "AUXILIO VIAL SOLUTIONS",
    "AMBURED",
    "ADILIO GAITAN",
    "ÁNGELA CABRERA",
    "BILLY ORTIZ",
    "CARLOS VIOLANTE",
    "CARLOS PINTO",
    "CARLOS LAZARO",
    "CERRAJERIA PALACIOS",
    "CESAR XITUMUL",
    "CHRISTIAN HERNANDEZ",
    "CLAUDIA ALONSO",
    "DANIEL BORJA",
    "DANIEL SOLORZANO",
    "DAVID MOZ",
    "DAVID NOVOA",
    "DAVID SEGOVIA",
    "DORIS PIZARRO",
    "FERNANDO",
    "GRUAS APC",
    "GRUAS ALTARNAAN",
    "GRUA GALDAMEZ",
    "GRUAS BELTRAN",
    "GRUAS CAMILA",
    "GRUAS CARMENCITA",
    "GRUAS VALENTINA",
    "GRUAS D Y A",
    "GRUAS DE LA CRUZ",
    "GRUAS JC",
    "GRUAS MAURO",
    "GRUAS UMAÑA",
    "GRUAS W Y V",
    "GRUAS MATTHEW",
    "GRUAS SOLO",
    "GRUAS SOMOZA",
    "GRUAS CARRILLO",
    "GRUAS WILL",
    "GRUAS RENZO",
    "GRUAS HERNANDEZ",
    "GRUAS G Y C",
    "GRUAS Q",
    "GRUAS MICHAEL",
    "GRUAS INTRANSA",
    "GRUAS DOÑA FRANCISCA",
    "GRUAS SAN ANTONIO",
    "GRUAS MIGUEL",
    "GRUAS KM 24",
    "GRUAS DE OCCIDENTE",
    "GRUAS HM",
    "HALMAR CASTILLO",
    "HENRY RETANA",
    "HORSINY TORRES",
    "ISRAEL DE LA CRUZ",
    "JONATHAN SURA",
    "JORGE GARCIA",
    "JOSE DOMINGUEZ",
    "JOSEFINA ORTIZ",
    "JOSUE IVAN MARTINEZ",
    "JULIO CESAR CHACON",
    "JUAN BAUTISTA",
    "JUAN HERRERA",
    "JOSUE LOPEZ",
    "JOSCAR BADO",
    "LUIS UMANZOR",
    "LUIS VARGAS",
    "LUIS VALDIZON",
    "MARCO RECOPACHI",
    "MARIELA JUAREZ",
    "MARIA PERALTA",
    "MARIO FRANCO",
    "MARYIN ALEXIS BONNILLA",
    "MIGUEL HERNÁNDEZ",
    "ODIR MERINO",
    "PEDRO PABLO",
    "RUDY GONZALEZ",
    "SALVADOR FUENTES",
    "SERVIGRUA",
    "SIN ASIGNAR",
    "WILBER DIAZ",
    "YUVINY SOLORZANO",
    "SERVIALES",
    "SERVIASISTENCIA",
    "T-ASISTE",
    "TRIPLE TOWN",
    "ROLANDO ARANA",
    "PHILLIP CORDOBA",
    "WILLIAM QUIJADA",
    "EXCEDENTE",
  ],
  list_depaOrigen: [
    "AHUACHAPAN",
    "CABAÑAS",
    "CHALATENANGO",
    "CUSCATLAN",
    "LA LIBERTAD",
    "LA PAZ",
    "LA UNION",
    "MORAZAN",
    "SAN MIGUEL",
    "SAN SALVADOR",
    "SAN VICENTE",
    "SANTA ANA",
    "SONSONATE",
    "USULUTAN",
    "NO REQUERIDO",
  ],
  list_muniOrigen: ["NO REQUERIDO"],
  list_depaDestino: [
    "AHUACHAPAN",
    "CABAÑAS",
    "CHALATENANGO",
    "CUSCATLAN",
    "LA LIBERTAD",
    "LA PAZ",
    "LA UNION",
    "MORAZAN",
    "SAN MIGUEL",
    "SAN SALVADOR",
    "SAN VICENTE",
    "SANTA ANA",
    "SONSONATE",
    "USULUTAN",
    "NO REQUERIDO",
  ],
  list_muniDestino: ["NO REQUERIDO"],
  list_tipoAsistencia: [
    "AJUSTE",
    "AJUSTE ADMINISTRATIVO",
    "AMBULANCIA",
    "AUXILIO VIAL",
    "ABASTO DE COMBUSTIBLE",
    "ASISTENCIA PARA TERCERO",
    "CAMBIO DE LLANTA",
    "CERRAJERIA",
    "CERRAJERIA HOGAR",
    "CONSULTA MEDICA TELEFONICA",
    "ELECTRICIDAD HOGAR",
    "FONTANERIA HOGAR",
    "GRUA LIVIANA",
    "GRUA PESADA",
    "GRUA POR ACCIDENTE LIVIANA",
    "GRUA POR ACCIDENTE PESADA",
    "GRUA PARA MOTOCICLETA",
    "GRUA PARA TERCERO",
    "INSPECCION ON LINE",
    "LEGAL",
    "LEGAL INTRUCCION",
    "LEGAL VISTA PUBLICA",
    "LEGAL APELACION",
    "MANIOBRA",
    "MENSAJERIA",
    "ORIENTACION LEGAL TELEFONICA",
    "PASO DE CORRIENTE",
    "PARTE POLICIAL",
    "TAXI",
    "TIEMPO DE ESPERA",
    "VALUO DE DAÑOS",
    "INFORMATIVO",
    "GESTION ADMINISTRATIVA",
    "DESPLAZAMIENTO EXTRA POR AJUSTE",
    "SUPERVISION",
    "QUEJA",
    "CONDUCTOR DESIGNADO",
    "NO REQUERIDO",
  ],
  list_localForaneo: ["LOCAL", "FORANEO", "INTERNACIONAL", "NO REQUERIDO"],
  list_estatusAsistencia: [
    "EN PROCESO",
    "SIN ASIGNAR",
    "CANCELADO",
    "FINALIZADO",
    "SERVICIO MUERTO/BANDERAZO",
    "REMITIDO",
    "EN TRAMITE",
  ],
  list_metodoSolicitud: ["LLAMADA", "WHATSAPP", "APP MÓVIL"],
  list_inspeccionInSituVirtual: [
    "INSPECCION IN SITU",
    "INSPECCION VIRTUAL",
    "NO APLICA",
  ],
  list_rapiAssaAsegurado: ["SI", "NO"],
  list_rapiAssaTercero: ["SI", "NO", "NO APLICA"],
  list_usoGruaAsegurado: ["MULTIMARCA", "ROTULADA", "NO APLICA"],
  list_estadoVirtual: ["REGISTRADO", "SIN POLIZA"],
  list_redTalleres: [
    "Quality Car Services",
    "Taller Morcar",
    "Taller Global Motors",
    "Renova Autos (Liviano)",
    "Sport Car-Estadio Cuscatlán",
    "Sport Car-Constitución",
    "Taller Semac",
    "Taller Fast Track",
    "Tecni-Auto",
    "Tune Up Service",
    "Megasystem-RapiAssa",
    "Racing Sport-RapiAssa",
    "Pintauto-RapiAssa",
    "Diparvel Panamericana",
    "Taller Funes",
    "Taller Granados González (Inactivo)",
    "A&M Automotriz-RapiAssa",
    "Cristobal's-RapiAssa",
    "Automotriz Trujillo",
    "MEGASYSTEM",
    "PINTAUTO",
    "RACING SPORT",
    "SAN CRISTOBAL",
    "A&M AUTOMOTRIZ",
    "AGENCIA",
    "PAGO AZULADO",
    "PAGO DIRECTO",
    "Ver motivos de no taller",
    "GRUPO Q ARBOL DE LA PAZ",
    "GRUPO Q LOS PROCERES",
    "GRUPO Q SAN MIGUEL",
    "TALLER DIAZ MOTORS",
    "RENOVA AUTOS  TONACATEPEQUE ( LIVIANOS Y PESADOS )",
    "VALUACION BDEO",
    "NO DETERMINADO",
  ],
  list_motivoNoUsoRapiassa: [
    "INFERIOR A FRANQUICIA",
    "MAYOR A $1000",
    "REQUIERE DE GRUA",
    "SE MOVILIZO SIN AUTORIZACION",
    "NUNCA HA TENIDO LICENCIA",
    "NO ESTA EN BASES",
    "TIPO DE VEHICULO",
    "TIPO DE POLIZA",
    "NO ELEGIBLE SEGÚN APLICATIVO ASSA",
    "NO DETERMINA TALLER",
    "TALLER DE CONFIANZA",
    "PAGO AZULADO",
    "PAGO DIRECTO/TALLER DE RED",
    "POLIZA SOLO  R.C",
    "USARA POLIZA SOLO PARA TERCERO",
    "USARA AGENCIA",
    "PREFIERE PROCESO CONVENCIONAL",
    "NO APLICA",
    "USO DE VALUACION BDEO",
    "SI SE UTILIZA",
    "HORARIO NO HÁBIL PARA BDEO",
  ],
  list_motivoDeNoTaller: [
    "No existió tercero",
    "No posee daños - Asegurado",
    "Tercero responsable",
    "No hará uso de póliza - Asegurado",
    "Tercero dio cobertura",
    "Sin cobertura - Asegurado",
    "Sin cobertura - Tercero",
    "No hará uso de póliza - Tercero",
    "No posee daños - Tercero",
    "Sin daños en ambas partes",
    "No asegurado con assa",
    "Robo total",
    "Asegurado no acepta responsabilidad",
    "Responsabilidad no determinada",
    "Daños en inmueble",
    "Incautado",
    "Responsabilidad compartida",
    "FORTUITO",
    "NO HAY DATO DE TERCERO",
    "TERCERO RESPONSABLE SIN SEGUROS",
    "CONCILIO EN EL LUGAR",
    "ATROPELLAMIENTO DE PEATON",
    "ATROPELLAMIENTO ANIMAL",
  ],
  metodos: {
    async listarOperadoresGrua() {
      return await axio.get("api/OperadoresGruas/Listar");
    },
  },
};
